import { createStore } from "vuex";

export default createStore({
  state: {
    site: null,
  },
  mutations: {
    commit_site(state, data) {
      state.site = data;
    },
  },
  actions: {},
  modules: {},
});
